package it.neckar.lizergy.model.price

/**
 * The product categories of the price list that are offered as a spreadsheet download.
 */
enum class PriceListExportCategory(
  /**
   * Identifies the category within the export URL
   */
  val urlSlug: String,

  /**
   * Names the category in the UI, the sheet and the downloaded file
   */
  val label: String,
) {
  Modules("modules", "Module"),
  Inverters("inverters", "Wechselrichter"),
  HybridInverters("hybrid-inverters", "Hybrid-Wechselrichter"),
  BatteryStorages("battery-storages", "Batteriespeicher"),
  BatteryInverters("battery-inverters", "Batterie-Wechselrichter"),
  HeaterRods("heater-rods", "Heizstäbe"),
  Wallboxes("wallboxes", "Wallbox"),

  ;

  /**
   * The name of the downloaded file
   */
  val fileName: String
    get() = "Preisliste $label.xlsx"

  companion object {
    fun forUrlSlug(urlSlug: String): PriceListExportCategory {
      return entries.find { it.urlSlug == urlSlug } ?: throw IllegalArgumentException("Unknown price list export category <$urlSlug>")
    }
  }
}
